"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBlueprint = exports.createBlueprint = void 0;
var _lodashEs = require("lodash-es");
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _env = _interopRequireDefault(require("../../../utilities/env"));
const globalStore = new Map();
const devtoolsMiddleware = function (storeId) {
  return function (stateCreator) {
    return (0, _middleware.devtools)(stateCreator, {
      name: "blueprint",
      store: storeId,
      enabled: ["dev", "development", "qa", "stage"].some(function (environment) {
        return environment === (0, _env.default)("REACT_APP_ENV") || environment === (0, _env.default)("NODE_ENV");
      })
    });
  };
};
const useBlueprint = function (_ref) {
  var _store$getState;
  let {
    id = undefined,
    blueprint,
    initialValues = {
      wait: false
    }
  } = _ref;
  const typedStore = globalStore;
  if (!typedStore.has(id)) {
    const castBlueprintArray = [blueprint].flat();
    const creator = (0, _lodashEs.flowRight)(devtoolsMiddleware(id), ...castBlueprintArray)(initialValues);
    typedStore.set(id, (0, _zustand.create)(creator));
  }
  const store = typedStore.get(id);
  const isWaiting = store === null || store === void 0 ? void 0 : (_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : _store$getState.wait;
  if (isWaiting && !(initialValues !== null && initialValues !== void 0 && initialValues.wait)) {
    store.setState({
      ...initialValues,
      wait: false
    });
  }
  return new Proxy(store, {
    get(target, prop, receiver) {
      // const isWaiting = target((state) => state["wait"]);
      const attribute = target(function (state) {
        return state === null || state === void 0 ? void 0 : state[prop];
      });
      const derivedAttr = target(function (state) {
        return state === null || state === void 0 ? void 0 : state[`_${String(prop)}`];
      });

      // TODO: An issue occurs with this wait pattern that returns undefined for all values while waiting
      // if the value being derived is using a hook, since it breaks the same number of hooks rule.
      // Should we consider allowing derived values to execute regardless of wait, but set everything else to undefined?

      // if (isWaiting && prop !== "wait") return undefined;

      if (typeof attribute !== "undefined" || typeof derivedAttr !== "undefined") {
        if (typeof derivedAttr !== "undefined") {
          return derivedAttr();
        }
        return attribute;
      }
      return Reflect.get(target, prop, receiver);
    }
  });
};
exports.useBlueprint = useBlueprint;
const createBlueprint = function (storeFn) {
  return function (initialValues) {
    return function (set, get) {
      return {
        ...storeFn(set, get),
        ...initialValues
      };
    };
  };
};
exports.createBlueprint = createBlueprint;